import React, { useState, useEffect, useRef, useCallback } from 'react';
import * as d3 from 'd3';
import CommonHoldersBubbleMap from './TokenCommonHoldersBubbleMap.component';
import { Box, Card, Typography, useTheme } from '@mui/material';


function BubbleChartComponent({ tokenId }) {
    const theme = useTheme();

    return (<Card>
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                padding: "20px",
            }}
        >
            <Typography
                variant="h6"
                sx={{
                    fontWeight: 700,
                    textAlign: "center",
                    marginBottom: "20px",
                }}
            >
                Related Tokens by Common Ownership
            </Typography>
            <CommonHoldersBubbleMap tokenIdToFetch={tokenId} />
        </Box>

    </Card>);


    return (
        <Box>
            <Typography
                variant="h6"
                sx={{
                    fontWeight: 700,
                    textAlign: "center",
                    marginBottom: "20px",
                }}
            >
                Related Tokens by Common Ownership
            </Typography>
            <CommonHoldersBubbleMap tokenIdToFetch={tokenId} />
        </Box>
    );
}

export default BubbleChartComponent;